// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { get } from 'lodash';
import { LOCATION_CHANGE } from 'react-router-redux';
import appConfig from '@nerdwallet/app-config';
import { submitSearch, submitProductSearch } from '~/client/lib/actions';

const baseUri = appConfig.BASE_URI;

export default [
  {
    path: baseUri,
    // eslint-disable-next-line no-unused-vars
    loadData: ({ store, req, res, match }, callback) => {
      callback();
    },
    routes: [
      {
        path: `${baseUri}/results`,
        // eslint-disable-next-line no-unused-vars
        loadData: ({ store, req, res, match, location }, callback) => {
          Promise.resolve()
            // update store with location, because the action isn't fired by react-router-redux until componentDidMount
            .then(() =>
              store.dispatch({
                type: LOCATION_CHANGE,
                payload: location,
              })
            )
            // eslint-disable-next-line consistent-return
            .then(() => {
              const state = store.getState();
              const { searchTerm, page, facets } = get(state, 'params', {});
              if (!searchTerm) return callback(); // Don't bother with API calls for empty queries
              Promise.all([
                store
                  .dispatch(
                    submitSearch({
                      searchTerm,
                      page,
                      facets,
                    })
                  )
                  .catch(() => {}),
                store
                  .dispatch(
                    submitProductSearch({
                      searchTerm,
                    })
                  )
                  .catch(() => {}),
              ]).then(() => callback());
            });
        },
      },
    ],
  },
];
